import { IGenerateImportProps, IGenerateImportPropsReturned } from '@interfaces/import/import';

import { EImportingDataType } from '@enums/dropzone';

export const generateImportProps = ({
	downloadSitesSampleFile,
	importSitesTypes,
	allSitesFields,
	saveSitesImportRules,
	executeSitesImport,
	isLoadingSitesFieldsMapping,
	isLoadingSitesImportRules,
	isLoadingSitesResultStatistic,
	isUploadingSitesFile,
	saveSitesFieldsMapping,
	sitesFieldsSamples,
	sitesSystemFields,
	sitesImportStatistic,
	createSitesUploadUrl,
	createPolygonUploadUrl,
	downloadPolygonSampleFile,
	executePolygonImport,
	isLoadingPolygonFieldsMapping,
	isLoadingPolygonResultStatistic,
	isUploadingPolygonFile,
	polygonFieldsSample,
	polygonImportStats,
	polygonSystemFields,
	savePolygonFieldsMapping,
	allAssetFields,
	assetFieldsSamples,
	assetImportStatistic,
	assetSystemFields,
	createAssetUploadUrl,
	downloadAssetSampleFile,
	executeAssetImport,
	importAssetTypes,
	isLoadingAssetFieldsMapping,
	isLoadingAssetImportRules,
	isLoadingAssetResultStatistic,
	isUploadingAssetFile,
	saveAssetFieldsMapping,
	saveAssetImportRules,
	numRowsAssets,
	importType,
	setAssetImportIds,
	assetImportIds,
	siteImportIds,
	numRowsSites,
	setSiteImportIds,
	polygonImportIds,
	setPolygonImportIds,
}: IGenerateImportProps): IGenerateImportPropsReturned => {
	if (importType === EImportingDataType.asset) {

		return ({
			createUploadUrl: createAssetUploadUrl,
			downloadSample: downloadAssetSampleFile,
			executeImport: executeAssetImport,
			fieldsSamples: assetFieldsSamples,
			importIds: assetImportIds,
			importStatistic: assetImportStatistic,
			isLoadingFieldsMapping: isLoadingAssetFieldsMapping,
			isLoadingResultStatistic: isLoadingAssetResultStatistic,
			isUploadingFile: isUploadingAssetFile,
			saveFieldsMapping: saveAssetFieldsMapping,
			setImportIds: setAssetImportIds,
			systemFields: assetSystemFields,
			importTypes: importAssetTypes,
			allFields: allAssetFields,
			saveImportRules: saveAssetImportRules,
			isLoadingImportRules: isLoadingAssetImportRules,
			numRows: numRowsAssets,
			moduleName: 'Asset',
		});
	} else if (importType === EImportingDataType.site) {

		return ({
			createUploadUrl: createSitesUploadUrl,
			downloadSample: downloadSitesSampleFile,
			executeImport: executeSitesImport,
			fieldsSamples: sitesFieldsSamples,
			importIds: siteImportIds,
			importStatistic: sitesImportStatistic,
			isLoadingFieldsMapping: isLoadingSitesFieldsMapping,
			isLoadingResultStatistic: isLoadingSitesResultStatistic,
			isUploadingFile: isUploadingSitesFile,
			saveFieldsMapping: saveSitesFieldsMapping,
			setImportIds: setSiteImportIds,
			systemFields: sitesSystemFields,
			importTypes: importSitesTypes,
			allFields: allSitesFields,
			saveImportRules: saveSitesImportRules,
			isLoadingImportRules: isLoadingSitesImportRules,
			numRows: numRowsSites,
			moduleName: 'Site',
		});
	}

	return ({
		createUploadUrl: createPolygonUploadUrl,
		downloadSample: downloadPolygonSampleFile,
		executeImport: executePolygonImport,
		fieldsSamples: polygonFieldsSample,
		importIds: polygonImportIds,
		importStatistic: polygonImportStats,
		isLoadingFieldsMapping: isLoadingPolygonFieldsMapping,
		isLoadingResultStatistic: isLoadingPolygonResultStatistic,
		isUploadingFile: isUploadingPolygonFile,
		saveFieldsMapping: savePolygonFieldsMapping,
		setImportIds: setPolygonImportIds,
		systemFields: polygonSystemFields,
		moduleName: 'Polygon',
		isLoadingImportRules: false,
	});
};
